import { render, staticRenderFns } from "./dap-wizard-methodology-composed.page.vue?vue&type=template&id=22c43640&scoped=true"
import script from "./dap-wizard-methodology-composed.page.vue?vue&type=script&lang=ts"
export * from "./dap-wizard-methodology-composed.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-wizard-methodology-composed.page.vue?vue&type=style&index=0&id=22c43640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c43640",
  null
  
)

export default component.exports